import request from '../request'
export default {
    /**
     * 登录
     */
    // login: (para, suss, err) => request.request('client/sys/applicationLogin', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
   
    /**
     * 修改密码
     */
    changePassword: (para, suss, err) => request.request('client/setup/changePassword', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 取得公司列表
     */
    getCompanyList: (para, suss, err) => request.request('client/setup/getCompanyList', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 设置默认公司
     */
    setDefaultCompany: (para, suss, err) => request.request('client/setup/setDefaultCompany', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
   
    /**
     * 获取当前用户个性签名
     */
    getSignature: (para, suss, err) => request.request('/client/setup/getSignature', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 创建问题接口
     */
    designSignature: (para, suss, err, complete_fun) => request.upload('client/setup/designSignature', para, () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }, () => { if (complete_fun !== undefined) { return e => { complete_fun(e) } } else { return null } }),
   
    /**
     * 取得消息列表
     */
    messageList: (para, suss, err) => request.request('client/message/messageList', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 取得用户详情
     */
    getPersonInfo: (para, suss, err) => request.request('client/personal/getPersonInfo', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    

    /**
     * 个人信息设置
     */
    personalCenter: (para, suss, err, complete_fun) => request.upload('client/personal/personalCenter', para, () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }, () => { if (complete_fun !== undefined) { return e => { complete_fun(e) } } else { return null } }),
    
    /**
     * 修改用户名
     */
    changeUsername: (para, suss, err) => request.request('client/personal/changeUsername', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 首页
     */
    getSY: (para, suss, err) => request.request('client/sy/getSY', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 首页
     */
    showAllInfo: (para, suss, err) => request.request('client/sy/showAllInfo', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 首页
     */
    getScoreInfo: (para, suss, err) => request.request('client/sy/getScoreInfo', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 首页
     */
    getTendencyChart: (para, suss, err) => request.request('client/sy/getTendencyChart', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    /**
     * 首页
     */
    getWaitBuild8D: (para, suss, err) => request.request('client/sy/getWaitBuild8D', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 首页-日历
     */
    getDeadlineChart: (para, suss, err) => request.request('client/sy/getDeadlineChart', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 退出登录
     */
    logout: (para, suss, err) => request.request('client/sys/logout', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 更新消息状态
     */
    update: (para, suss, err) => request.request('client/message/update', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 取得行业
     */
    getIndustry: (para, suss, err) => request.request('client/partner/getIndustry', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 取得公司信息
     */
    getCompanyInfo: (para, suss, err) => request.request('client/discoverProblem/getCompanyInfo', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 企业类型
     */
    getCompanyType: (para, suss, err) => request.request('ent/company/getCompanyType', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 获取根部门
     */
    getRootDepartment: (para, suss, err) => request.request('client/getRootDepartment', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
   
    /**
     * h5试用登记
     */
    addTryOut: (para, suss, err) => request.request('supplier/addTryOut', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * h5试用登记
     */
    checkExistRelevance: (para, suss, err) => request.request('wx/checkExistRelevance', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 前端日志
     */
    recordClientLog: (para, suss, err) => request.request('wx/recordClientLog', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),

}


// WEBPACK FOOTER //
// ./src/api/user.js